import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getTramitePorId } from '../services/tramiteService';
import { rutaDetalleTramite } from '../utils/rutasTramite';

export default function TramiteLegacyRedirect() {
    const navigate = useNavigate();
    const { idTramite } = useParams();

    useEffect(() => {
        const resolverRuta = async () => {
            if (!idTramite) {
                navigate('/rti/tramites', { replace: true });
                return;
            }

            try {
                const tramite = await getTramitePorId(idTramite);
                const destino = rutaDetalleTramite({ ...tramite, idTramite });
                navigate(destino, { replace: true });
            } catch (error) {
                // Fallback seguro para no dejar la pantalla en blanco.
                navigate(`/rti/tramites/${idTramite}`, { replace: true });
            }
        };

        resolverRuta();
    }, [idTramite, navigate]);

    return (
        <div className="container mt-4">
            <div className="alert alert-info mb-0">Redirigiendo al tramite...</div>
        </div>
    );
}

